import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function instructoresReducer(state= initialState.instructores, action){
	switch(action.type){
		case types.LOAD_INSTRUCTORES_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}